import React, { useEffect, useState, useRef } from "react";
import { get } from "util/requests";
import styles from "./dashboard.module.css";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import EnrollmentDashboard from "./dashboards/enrollment";
import DataQualityDashboard from "./dashboards/data_quality";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <React.Fragment>{children}</React.Fragment>}
    </div>
  );
}

export default function Dashboard() {
  const [search_params = [], setSearchParams] = useSearchParams();
  const [sitesRegions, setSitesRegions] = useState(null);
  const permissions = useSelector((state) => state.user.userData.permissions);

  let params = {};
  search_params.forEach((value, key) => (params[key] = value));

  useEffect(() => {
    get("/site_region_list_user_context").then((ret) => {
      if (ret.data?.sites?.length > 1) {
        ret.data.sites.unshift({ id: 0, name: "All Sites (all available)", code: 0 });
      }
      if (ret.data?.regions.length > 1) {
        ret.data.regions.unshift({ id: 0, name: "All Regions (all available)", code: 0 });
      }
      let _params = {};
      if (ret.data?.regions?.length) {
        _params = { ...params, filter: "region" };
        if (!_params.region) {
          _params.region = ret.data.regions[0].id;
        }
      } else if (ret.data?.sites?.length) {
        _params = { ...params, filter: "site" };
        if (!_params.site) {
          _params.site = ret.data.sites[0].id;
        }
      }
      setSearchParams(_params);
      setSitesRegions(ret.data);
    });
  }, []);

  const handleChange = (event, newValue) => {
    if (newValue === 0) {
      setSearchParams({ ...params, type: "enrollment" });
    } else if (newValue === 1) {
      setSearchParams({ ...params, type: "quality" });
    }
  };

  let type = search_params.get("type") || "enrollment";
  let value = 0;
  if (type === "enrollment") {
    value = 0;
  } else if (type === "quality") {
    value = 1;
  }

  let tabs = [];
  let panels = [];
  if (permissions.includes("enrollment_dashboard")) {
    tabs.push((index) => (
      <Tab
        label="Enrollment"
        {...a11yProps(index)}
        sx={{
          "&.MuiTab-root": {},
          "&.Mui-selected": {
            borderBottom: "0px",
          },
        }}
      />
    ));
    panels.push((index) => (
      <TabPanel value={value} index={index} key={index}>
        <div className={styles.tab_panel}>
          <EnrollmentDashboard params={params} setSearchParams={setSearchParams} sitesRegions={sitesRegions} />
        </div>
      </TabPanel>
    ));
  }
  if (permissions.includes("data_quality_dashboard")) {
    tabs.push((index) => <Tab label="Data Quality" {...a11yProps(index)} />);
    panels.push((index) => (
      <TabPanel value={value} index={index} key={index}>
        <div className={styles.tab_panel}>
          <DataQualityDashboard params={params} setSearchParams={setSearchParams} sitesRegions={sitesRegions} />
        </div>
      </TabPanel>
    ));
  }

  if (!sitesRegions) return null;

  return (
    <div className={styles.flex}>
      <div className={styles.header}>
        <div className={styles.search_wrapper}></div>
        <Tabs value={value} onChange={handleChange} aria-label="dashboard interface">
          {tabs.map((tab, index) => tab(index))}
        </Tabs>
        {panels.map((panel, index) => panel(index))}
      </div>
    </div>
  );
}
